var viewer_caption_rtlignore_default = {
  "fontElementMap": "_9JScJ",
  "imageCaption": "EvF8U"
};
export {
  viewer_caption_rtlignore_default as default
};
//# sourceMappingURL=viewer-caption.rtlignore-scss.js.map
